import {createAuthUrl} from "../../config/rootEpic";
import {apiUrl} from "../../components/common/getEnv";

export const userDetailsUrl = (userId) => createAuthUrl(`/iam/v1/auth/user/${userId}`);
export const userSearchUrl = (term) => `${apiUrl}/item_quality/users/search?term=${term}`;

export const sellerDetailsUrl = (userId) => `${apiUrl}/users/${userId}`;